function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFBD1A",
  cx: 16,
  cy: 16,
  r: 14.667
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.83 17.642c.968.986 1.958 1.951 2.92 2.942.214.22.312.186.506-.01.967-.988 1.95-1.96 2.924-2.939.153-.151.212-.23.419.008.547.626 1.164 1.191 1.768 1.794l-5.05 5.043c-.1.1-.185.212-.278.32h-.079c-.083-.098-.16-.2-.25-.29a2058.995 2058.995 0 0 0-4.843-4.836c-.206-.205-.253-.325-.014-.547.516-.477 1.01-.98 1.492-1.495.195-.207.301-.179.485.01zm3.21-3.637 1.955 1.956-2.011 2.003-1.95-1.95 2.005-2.009zm-6.629.217a51.91 51.91 0 0 0 1.573 1.576c.16.154.16.25 0 .405a49.486 49.486 0 0 0-1.573 1.574c-.192.202-.294.145-.46-.02-.575-.58-1.167-1.148-1.751-1.718v-.079c.584-.57 1.176-1.136 1.751-1.717.166-.167.268-.223.46-.02zm13.639.02c.576.58 1.125 1.189 1.75 1.718v.079c-.585.571-1.176 1.137-1.752 1.718-.166.166-.27.221-.46.02a51.842 51.842 0 0 0-1.572-1.575c-.16-.155-.157-.251.001-.404a50.056 50.056 0 0 0 1.545-1.548c.185-.194.29-.208.488-.008zM16.039 7.2c.084.098.16.2.25.29 1.612 1.613 3.219 3.231 4.843 4.832.24.237.221.356-.011.574-.515.478-1.01.98-1.493 1.49-.17.178-.258.173-.427.002-.986-1.002-1.99-1.989-2.976-2.993-.176-.18-.269-.186-.449-.003-.975.996-1.972 1.971-2.948 2.967-.188.192-.294.208-.485.005-.473-.503-.96-.994-1.465-1.466-.23-.215-.252-.338-.01-.576 1.623-1.6 3.23-3.218 4.842-4.831.09-.09.167-.193.25-.291h.079z",
  fill: "#FFF"
}));

function SvgIco24ChainBsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24ChainBsc);
export default __webpack_public_path__ + "static/media/ico_24_chain_bsc.1b5c6975.svg";
export { ForwardRef as ReactComponent };